(function($){
	OH.settings.parserDefine = (function(){
		var parsers = new Object();
    
    
		parsers.vueData = function(name){

			var $target = $('[data-resource-name="' + name + '"]').eq(0);

			var define = new Object();
			$target.find('[data-refine-define]').each(function(){
				var seq = new Array();
				var join = new Object();
				var $deflist = $(this);
				var list = {};
				$deflist.find('[data-define-key]').each(function(){
					var $item = $(this);
					var joinWith = $item.data("rel");
					list[OH.idPrefix + $item.data("defineKey")] = (joinWith === undefined) ? $item.text() : { join : joinWith, label : $item.text(), forbidden : true };
					seq.push($item.data("defineKey"));
					
					if(joinWith !== undefined){
						join[joinWith] = !!join[joinWith] ? join[joinWith] : [];
						join[joinWith].push(OH.idPrefix + $item.data("defineKey"));
					}
				});
				list.seq = seq;
				list.join = join;
				define[$deflist.data("refineDefine")] = list;
			});

			var result = new Array();
			$target.find('UL[data-refine-list] > LI').each(function(){
				var $item = $(this);
				var data = $item.find('input[type="hidden"]').eq(0).attr("value");
        data = JSON.parse(data);
				$item.find('[data-translation]').each(function(){
					data[$(this).data("translation")] = $(this).text();
				});
				result.push(data);
			});
			return { define : define, result : result.reverse() };
		};

		return parsers;
	})();
})(jQuery);
